import React, { useState } from "react";
import { useSite } from "@/context/SiteContext";
import { EnquiryDialog } from "@/components/EnquiryDialog";
import { Button } from "@/components/ui/button";
import { Phone, Mail, MapPin, Clock, ExternalLink } from "lucide-react";

export default function Contact() {
  const site = useSite();
  const [enq, setEnq] = useState(false);

  const cards = [
    { icon: Phone, title: "Call us", value: site.phone, href: `tel:${site.phone?.replace(/\s/g, "")}` },
    { icon: Mail, title: "Email us", value: site.email, href: `mailto:${site.email}` },
    { icon: MapPin, title: "Visit us", value: site.address, href: site.map_url },
    { icon: Clock, title: "Opening hours", value: site.hours, href: null },
  ];

  return (
    <div>
      <section className="bg-brand-navy text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <span className="font-mono-spec text-xs uppercase tracking-widest text-white">Contact Us</span>
          <h1 className="mt-3 font-display font-extrabold tracking-tight text-4xl sm:text-5xl">Get in touch</h1>
          <p className="mt-5 max-w-2xl text-lg text-white/80">We're here to answer your questions and help you find the right robotic mowing or line-marking solution.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {cards.map((c) => {
            const inner = (
              <>
                <span className="grid place-items-center h-11 w-11 rounded-xl bg-brand-navy/10 text-brand-navy"><c.icon className="h-5 w-5" /></span>
                <h3 className="mt-4 font-display font-semibold text-lg text-brand-navy flex items-center gap-1">{c.title} {c.href && <ExternalLink className="h-3.5 w-3.5 opacity-50" />}</h3>
                <p className="mt-1 text-muted-foreground break-words">{c.value}</p>
              </>
            );
            return c.href ? (
              <a key={c.title} href={c.href} target={c.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="rounded-2xl border border-brand-navy/10 bg-white p-6 transition-transform duration-200 hover:-translate-y-1" data-testid={`contact-${c.title.toLowerCase().replace(/\s/g, "-")}`}>{inner}</a>
            ) : (
              <div key={c.title} className="rounded-2xl border border-brand-navy/10 bg-white p-6">{inner}</div>
            );
          })}
        </div>

        <div className="rounded-3xl bg-brand-white border border-brand-navy/10 p-8 flex flex-col justify-center">
          <h2 className="font-display font-bold text-2xl text-brand-ink">Send us an enquiry</h2>
          <p className="mt-3 text-muted-foreground">Tell us about your requirements and our team will get back to you.</p>
          <Button onClick={() => setEnq(true)} size="lg" className="mt-6 w-fit bg-brand-navy hover:bg-brand-navy/90 text-white font-semibold" data-testid="contact-enquiry-button">Open enquiry form</Button>
        </div>
      </section>

      <EnquiryDialog open={enq} onOpenChange={setEnq} type="general" sourcePage="contact" />
    </div>
  );
}
